/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TransportSubmode {
  None = 0,
  Unknown = 1,
  DomesticFlight = 100,
  HelicopterService = 101,
  InternationalFlight = 102,
  AirportLinkBus = 200,
  ExpressBus = 201,
  LocalBus = 202,
  NightBus = 203,
  MetroReplacementBus = 204,
  RailReplacementBus = 205,
  MiniBus = 206,
  RegionalBus = 207,
  SchoolBus = 208,
  ShuttleBus = 209,
  SightseeingBus = 210,
  TramReplacementBus = 211,
  InternationalCoach = 300,
  NationalCoach = 301,
  TouristCoach = 302,
  AirportLinkRail = 400,
  International = 401,
  InterregionalRail = 402,
  Local = 403,
  LongDistance = 404,
  NightRail = 405,
  RegionalRail = 406,
  TouristRailway = 407,
  HighSpeedPassengerService = 500,
  HighSpeedVehicleService = 501,
  InternationalCarFerry = 502,
  InternationalPassengerFerry = 503,
  LocalCarFerry = 504,
  LocalPassengerFerry = 505,
  NationalCarFerry = 506,
  SightseeingService = 507,
  BusReplacementBoat = 508,
  RegionalCarFerry = 509,
  NationalPassengerFerry = 510,
  RegionalPassengerFerry = 511,
}
